// options.ts

// --- Single-select ---
export const EXPANSION_TYPES = [
  "Facility Expansion",
  "New Product Line",
  "Automation / Tech Upgrade",
  "Relocation within Jurisdiction",
  "M&A Integration",
];

export const REASONS_FOR_ENGAGEMENT = [
  "Proactive Outreach",
  "Company Request",
  "Referral / Partner",
  "At-Risk Alert",
  "Incentive Inquiry",
  "Permit / Regulatory Assistance",
];

// --- Multi-select ---
export const RETENTION_RISKS = [
  "Workforce Shortage",
  "Facility Constraints",
  "High Operating Costs",
  "Regulatory / Permitting",
  "Supply Chain",
  "Financing",
  "Market Demand",
  "Infrastructure Limitations",
];

export const SUPPORT_NEEDED = [
  "Workforce / Training",
  "Real Estate / Site",
  "Utility / Infrastructure",
  "Permitting / Regulatory",
  "Incentives / Financing",
  "Export / Market Access",
  "Supply Chain",
  "Other Services",
];

export const SITE_READINESS_OPTIONS = [
  "Shovel-ready (utilities & permits in place)",
  "Pad-ready (graded; utilities nearby)",
  "Utilities on-site; permits pending",
  "Zoned / Planned – infrastructure off-site",
  "Existing building – move-in ready",
  "Existing building – improvements needed",
  "Raw land – due diligence required",
  "Brownfield – remediation needed",
];

// ===================================================
// --- NEW DROPDOWNS ---
// ===================================================

export const SKILL_SETS = [
  "Forklift Operators",
  "General Laborers",
  "Machine Operators",
  "Maintenance Technicians",
  "Engineers (Mechanical, Electrical, Industrial)",
  "Sewing Machine Operators",
  "Welders/Fabricators",
  "Assembly Line Workers",
  "CNC Machinists",
  "Plant/Operations Managers",
  "Packaging Specialists",
  "IT Professionals",
  "Warehouse/Logistics Personnel",
  "Quality Assurance/Quality Control Technicians",
  "HVAC Technicians",
  "Programmers (Automation/PLC/Robotics)",
  "Sales and Customer Support Staff",
  "Office/Admin Support",
  "Line Leads/Supervisors",
  "Chemical Handlers or Lab Technicians",
  "Other",
];
